module.exports = __webpack_public_path__ + "static/img/b5-2.47f9cc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/b5-2.png
// module id = 1clE
// module chunks = 1